import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ActiveOrganisationState {
  organisationId: string | null;
  isSwitchingOrganisation: boolean;
}

const initialState: ActiveOrganisationState = {
  organisationId: null,
  isSwitchingOrganisation: false,
};

const slice = createSlice({
  name: 'activeOrganisation',
  initialState,
  reducers: {
    setOrganisationSwitching: (state, action: PayloadAction<boolean>) => {
      state.isSwitchingOrganisation = action.payload;
    },
    setActiveOrganisationId: (state, action: PayloadAction<string>) => {
      state.organisationId = action.payload;
    },
    clearActiveOrganisation: () => initialState,
  },
});

export const {
  setOrganisationSwitching,
  setActiveOrganisationId,
  clearActiveOrganisation,
} = slice.actions;

export default slice.reducer;
